<template>
  <div style="flex:1;width: 100%;
    height: 100%;" v-loading="this.$store.state.isLoading">
    <div class="act-form">
      <div class="upload_word">
         <div class="upload_word_btn">导入word</div> 
         <input class="upload_file" type="file" ref='upload_word'  @change="uploadWord($event)">
      </div>
      <iframe
        src="static/ewebeditor/ewebeditor.htm?id=content1&style=standard650"
        frameborder="0"
        scrolling="yes"
        style="background-color:transparent; position：absolute;"
        width="100%"
        class="iframe_hight"
        ref="iframe"
        ID="eWebEditor1"
      ></iframe>
    </div>
    <textarea
      name="content1"
      style="display:none"
    ></textarea>
    
    <!-- <button @click="submit">确定</button>
    <button @click="join">加入</button>
    <button @click="slect">选中</button> -->
    <!-- <div
      id="div1"
      ref="ifarm"
    ></div> -->
  </div>

</template>
<script>
import bus from "../../plugins/Bus";
export default {
  data() {
    return {
      iframe_height: "800",
      iframe_width: "800",
      list: []
    };
  },
  props: {
    defaultMsg: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    }
  },
  methods: {
    uploadWord(e){
      // console.log(e)
      let str='.'+e.target.files[0].name.split('.')[e.target.files[0].name.split('.').length-1]
      // console.log(str)
 
        var reg = "[.](doc|docx|DOC|DOCX|msword|word)$"
        var r = str.match(reg);
        if(r == null){
          this.$message.error({message:'请选择word文件，重新上传',duration:1500} );
          return
        }
        let formData = new FormData()
        formData.append('file',e.target.files[0])
        formData.append('server_url',JSON.parse(sessionStorage.userInfo).school.server_url)
        formData.append('schoolcode',JSON.parse(sessionStorage.userInfo).school_code)
         this.axios
          .post("https://www.gaokaowin.com/proxy/school/word2html/getWordHtml",formData)
          .then(res => {
           if(res.data.code==0){
              this.$message.error({message:res.data.msg,duration:1500} );
            }
            else if(res.status&&res.status==200){
            
             this.join(res.data)
              this.$refs.upload_word.value = null;
            //  console.log( this.$refs.upload_word)
              // this.addImgs_preview.unshfit(school_url+res.data.data)
            }else{
               this.$message.error({message:'导入失败',duration:1500} );
            }
            
          }).catch(error =>  this.$message.error({message:'导入失败',duration:1500} ))
      },
   
    insert_something(){
      this.$refs.iframe.contentWindow.insertHTML('<span>'+1111+'</span>')
    },
    getContent() {
      return this.$refs.iframe.contentWindow.getHTML();
    },
    join(contnet) {
      this.$refs.iframe.contentWindow.insertHTML(contnet);
      //   console.log();
    },
    setContent1(content) {
     
      var _this = this;
      try {
       
         _this.axios.post("/school/index/index").then(res => {
          //  console.log(1111)
            setTimeout(function() {
              // console.log(1)
              try {
                return _this.$refs.iframe.contentWindow.setHTML(content);
              } catch (error) {
                return _this.$refs.iframe.contentWindow.setHTML('');
              }
              
            }, 200);
         })

       
        // setTimeout(function() {
        //   return _this.$refs.iframe.contentWindow.setHTML(content);
        // }, 20);
      } catch (err) {
        console.log(err);
      }
    },
    setContent(content) {
   
    //  console.log(1)
      var _this = this;
      try {
        document.querySelector("#eWebEditor1").onload = function() {
          // console.log(content)
  
           _this.axios.post("/school/index/index").then(res => {
             
            setTimeout(function() {
               console.log(content); 
              return _this.$refs.iframe.contentWindow.setHTML(content);
          
            }, 200);
         })

        };
        // setTimeout(function() {
        //   return _this.$refs.iframe.contentWindow.setHTML(content);
        // }, 20);
      } catch (err) {

      //   console.log("vueFunc ");
      }
    },
    setContent_exam(content) {
      // alert(1)
    //  console.log(1)
      var _this = this;
      // try {
        // document.querySelector("#eWebEditor1").onload = function() {
          // console.log(content)
          setTimeout(function() {
            return _this.$refs.iframe.contentWindow.setHTML(content);
          }, 100);
        // };
        // setTimeout(function() {
        //   return _this.$refs.iframe.contentWindow.setHTML(content);
        // }, 20);
      // } catch (err) {
      //   console.log("vueFunc ");
      // }
    },
    // EWEBEDITOR_EVENT(ev) {
    //   console.log(ev);
    //   //响应事件处理代码
    // },
    getText() {
      // console.log(this.$refs.iframe.contentWindow.getSelectedText());

      // var a = text.substring(text.indexOf(ht), 0);
      // console.log(a);
      // this.EWEBEDITOR_EVENT(this.$refs.iframe.contentWindow.getSelected());
      // this.$refs.iframe.contentWindow.getSelectedText().remove();

      if (this.$refs.iframe.contentWindow.getSelectedHTML() != "") {
        var content =
          "<div>" +
          this.$refs.iframe.contentWindow.getSelectedHTML() +
          "</div>";
        // console.log(content);
        return content;
      }
    },
    getText1() {
      if (this.$refs.iframe.contentWindow.getSelectedText() != "") {
        var txt = this.$refs.iframe.contentWindow.getSelectedText();
        var reg = /\d\.[\s|\n]+(.*。)\s?([A-Z]\..*)\s?答案：(.*)/i;
        var _this = this;
        this.$refs.iframe.contentWindow.exec("delete");
        setTimeout(function() {
          // console.log(
          //   _this.$refs.iframe.contentWindow
          //     .getSelectedElement()
          //     .document.delete()
          // );
          // _this.$refs.iframe.contentDocument
          //   .getSelectedElement()
          //   .document.execCommand("Delete");
        }, 500);
        // var sss = this.$refs.iframe.contentWindow.getText();
        // var a = "";
        // console.log(txt);
        // console.log(sss);
        // a = sss.replace(txt);
        // console.log(a);
        //  this.setContent(a);
        // this.$refs.iframe.contentWindow.setHTML(a);

        return txt;
      } else {
        this.$message({
          showClose: true,
          message: "请选择字符",
          type: "error",
          duration:500,showClose: true
        });
      }
      // var ht = this.$refs.iframe.contentWindow.getSelectedText();

      var text = txt.match(reg);

      // console.log(text);
      if (text != null) {
        this.list.push({
          title: text[1],
          option: text[2],
          answer: text[3],
          changge: true,
          color: "#808fa3"
        });

        bus.$emit("list", this.list);
        this.$store.state.topics = this.list;
        this.$store.state.arraylist = this.list;
        return text;
      } else {
        alert("格式不正确");
      }
    }
  },
  beforeDestroy() {
    bus.$off("list");
    bus.$off("edit_qs_content");
  },
  mounted() {
    bus.$on("edit_qs_content", content => {
      // console.log(content);
      this.$refs.iframe.contentWindow.setHTML(content);
    });
    // console.log("aaaaaaa");
    // this.iframe_height = window.innerHeight;
    // this.iframe_width = window.innerWidth;
    // EWEBEDITOR.Append(
    //   "div1",
    //   {
    //     style: "coolblue",
    //     width: this.iframe_width,
    //     height: this.iframe_height
    //   },
    //   "初始值"
    // );
    // var html = this.$refs.ifarm.getHTML();
    // console.log(this.$refs.iframe.contentWindow.document.body);
    // var editor1 = document
    //   .querySelector("#eWebEditor1")
    //   .contentWindow.getHTML();
    // console.log(editor1);
    //   .contentWindow;
    // console.log(document.querySelector("#eWebEditor1"));
    // console.log(editor1.getHTML());
    // if (editor1.getHTML() == "") {
    //   alert("内容不能为空！");
    //   return false;
    // }
    // window.addEventListener("message", function(event) {
    //   console.log(event);
    // });
    // window.addEventListener("scroll", this.showmenu, { passive: true });
    // window.addEventListener("message", function(event) {
    //   console.log(event);
    // });
    // console.log(window.innerWidth);
    // console.log(this.$refs.iframe.clientHeight);
    // this.iframe_height = window.innerHeight;
    // this.iframe_width = window.innerWidth;
    // this.iframe_height = Number(iframe_height) - 100 + "px";
  }
};
</script>
<style scoped>
.act-form {
  height: 100%;
}
.iframe_hight{
  height: calc(100% - 40px);
  
}
.upload_word{
  height: 40px;
  position: relative;
}
.upload_word_btn{
  width: 120px;
  height: 40px;
  text-align: center;
  background: #409EFF;
  color: white;
  border-radius: 6px;
  line-height: 40px;
  cursor: pointer;
}
.upload_file{
  position:absolute;
  width:120px;
  height:40px;
  left:0;
  top:0;
  cursor: pointer;
  opacity:0
}
</style>